const EXTERNAL_VIDEO_CONSENT_KEY = 'udemy-external-video-consent-youtube';

/** YouTube terms of service — linked from the third-party content disclaimer. */
export const YOUTUBE_TERMS_URL = 'https://www.youtube.com/t/terms';

/** Returns whether the user opted to remember external video consent this session. */
export function hasExternalVideoConsent(): boolean {
    if (typeof sessionStorage === 'undefined') return false;
    return sessionStorage.getItem(EXTERNAL_VIDEO_CONSENT_KEY) === 'true';
}

/** Persists external video consent for the current browser session. */
export function setExternalVideoConsent(): void {
    if (typeof sessionStorage === 'undefined') return;
    sessionStorage.setItem(EXTERNAL_VIDEO_CONSENT_KEY, 'true');
}
